import { ConstantsParser } from '../../../ConstantsParser'
import { StylesParser } from '../../../StylesParser'
export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content =  new Object
    this.view = this.viewHtml()
  }

  viewHtml() {
    let activeClasses = (new ConstantsParser(this.activeClasses())).parse().join(' ')
    let activeStyles = (new StylesParser(this.activeStyles())).parse()
    activeStyles =  Object.keys(activeStyles).map(variationStyle => `${variationStyle}:${activeStyles[variationStyle]}`).join(';')
    let inactiveClasses = (new ConstantsParser(this.inactiveClasses())).parse().join(' ')
    let inactiveStyles = (new StylesParser(this.inactiveStyles())).parse()
    inactiveStyles = Object.keys(inactiveStyles).map(variationStyle => `${variationStyle}:${inactiveStyles[variationStyle]}`).join(';')
    return `<div class="wf-flex">
      <div class="${activeClasses} wf-px-3" style="${activeStyles}">Tab 1</div>
      <div class="${inactiveClasses} wf-px-3" style="${inactiveStyles}">Tab 2</div>
    </div>`
  }

  containerClasses() {
    return [
      {property: 'Display', value: 'FLEX'},
      {property: 'Flex', value: 'FLEX_COL'}
    ]
  }

  tabsClasses() {
    return [
      {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
    ]
  }

  activeClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_BASE'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
      {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
    ]
  }

  inactiveClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_BASE'},
      {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
    ]
  }

  contentClasses() {
    return [
      {property: 'Shadow', value: 'SHADOW_MD'},
    ]
  }

  containerStyles() {
    return []
  }

  tabsStyles() {
    return []
  }

  activeStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: 'rgba(138.24,115.2,115.2, 1)'},
      {property:'BorderColor', styleProperty: 'border-color', value:'#8A7373'},
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, rgba(216,180,180, 1),rgba(216,180,180, 1))'},
    ]
  }

  inactiveStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#A0AFAF'},
    ]
  }

  contentStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff, #ffffff)'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      tabsStyles: {
        desktop: this.tabsStyles(),
        tablet: this.tabsStyles(),
        phone: this.tabsStyles(),
      },
      containerStyles: {
        desktop: this.containerStyles(),
        tablet: this.containerStyles(),
        phone: this.containerStyles(),
      },
      activeStyles: {
        desktop: this.activeStyles(),
        tablet: this.activeStyles(),
        phone: this.activeStyles(),
      },
      inactiveStyles: {
        desktop: this.inactiveStyles(),
        tablet: this.inactiveStyles(),
        phone: this.inactiveStyles(),
      },
      contentStyles: {
        desktop: this.contentStyles(),
        tablet: this.contentStyles(),
        phone: this.contentStyles(),
      },
      tabsClasses: {
        desktop: this.tabsClasses(),
        tablet: this.tabsClasses(),
        phone: this.tabsClasses(),
      },
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses(),
      },
      activeClasses: {
        desktop: this.activeClasses(),
        tablet: this.activeClasses(),
        phone: this.activeClasses(),
      },
      inactiveClasses: {
        desktop: this.inactiveClasses(),
        tablet: this.inactiveClasses(),
        phone: this.inactiveClasses(),
      },
      contentClasses: {
        desktop: this.contentClasses(),
        tablet: this.contentClasses(),
        phone: this.contentClasses(),
      },
    }
  }
}
